import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Redirect component that performs a 301 permanent redirect
 * For SEO purposes, we also set a meta refresh as fallback
 */
export function Redirect301({ to }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Preserve query params and hash
    const newPath = to + location.search + location.hash;
    
    // For SEO: Add canonical link (helps search engines)
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = window.location.origin + newPath;
    document.head.appendChild(link);

    // Navigate to new URL (replaces history entry)
    navigate(newPath, { replace: true });

    return () => {
      // Cleanup canonical link
      document.head.removeChild(link);
    };
  }, [navigate, to, location.search, location.hash]);

  return null;
}

export default Redirect301;
